import type { MailFolder } from 'owa-graph-schema';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function getEffectiveFolderDisplayName(
    folder: Pick<MailFolder, 'remoteFolderInfo' | 'displayName'>
): string {
    if (!folder) {
        return '';
    }

    if (
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (15,9): Object is possibly 'undefined'.
        // @ts-expect-error
        getUserConfiguration().SessionSettings.IsShadowMailbox &&
        folder.remoteFolderInfo?.remoteFolderDisplayName
    ) {
        return folder.remoteFolderInfo.remoteFolderDisplayName;
    }

    return folder.displayName;
}
